import { useGroups } from '@entities/common/groups';
import { useIdsSelecting } from '@entities/common/IdsSelector/models.ts';
import { useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { useLoadGroups } from '@features/common';
import { Add } from '@shared/assets';
import { parseGroups } from '@shared/helpers/parse-groups.ts';
import type { Group } from '@shared/types/common';
import { IconButton, ListBody, PageHead, TextButton } from '@shared/ui';
import { Blank } from '@src/library/components/common/index.ts';
import GroupItem from '../../../../../../pages/clients/groups-page/group-item/ui.tsx';
import * as st from './styles.module.scss';

export const GroupsPage = () => {
  const {
    groups,
    selectedGroups,
    isSelectedAtAnyGroups,
    removeFromSelectedGroups,
    addSelectedToGroups,
    prevSelectedGroups,
    setPrevSelectedGroups,
  } = useGroups();
  const navigate = useNavigate();
  const { status } = useLoadGroups(true);

  const without_group: Group | undefined = groups.find((group) => {
    if (group.special_type === 'without_group') return group;
  });

  const handleConfirm = () => {
    if (without_group && selectedGroups.length === 0) addSelectedToGroups(without_group);
    if (!!selectedGroups.find((group) => group.special_type === null) === true)
      without_group && removeFromSelectedGroups(without_group);
    navigate(-1);
  };

  useEffect(() => {
    setPrevSelectedGroups(selectedGroups);
  }, [prevSelectedGroups]);

  const { groupsWithoutSpecialType } = useMemo(() => parseGroups(groups), [groups]);

  const {
    isSelecting: isGroupsSelecting,
    setIsSelectingFalse,
    setIsSelectingTrue,
  } = useIdsSelecting('groups');

  useEffect(() => {
    setIsSelectingTrue();
    return () => {
      setIsSelectingFalse();
    };
  }, []);
  const isLoading = status === 'loading';

  const onGroupSelecting = (group: Group) => {
    const isSelected = isSelectedAtAnyGroups(group);
    isSelected ? removeFromSelectedGroups(group) : addSelectedToGroups(group);
  };

  return (
    <>
      <PageHead
        Center={'Выбор групп'}
        Right={
          <>
            <Tooltip title="Добавить">
              <div>
                <Link to={`/clients/groups/edit/new`}>
                  <IconButton variant="dark">
                    <Add />
                  </IconButton>
                </Link>
              </div>
            </Tooltip>
            {isGroupsSelecting && (
              <TextButton
                type="button"
                onClick={() => {
                  handleConfirm();
                  setIsSelectingFalse();
                }}
              >
                Готово
              </TextButton>
            )}
          </>
        }
      />

      <ListBody>
        <InfinityList loadMore={() => {}} loading={isLoading} className={st.groupList}>
          {groupsWithoutSpecialType.map((group) => (
            <GroupItem onSelecting={() => onGroupSelecting(group)} key={group.id} group={group} />
          ))}
          {!isLoading && !groups.length && <Blank text={'У вас пока нет групп'} />}
        </InfinityList>
      </ListBody>
    </>
  );
};
